import React, { useState } from 'react'
// import { CSVLink } from "react-csv";
// export default function CsvDownload({headers,data ,filename}) {
//   return (
//     <CSVLink filename={filename} className='export-btn' headers={headers} data={data}>Export Table</CSVLink>
//   )
// }
// download={usertype.csv}
export default function CsvDownload(props) {
  const { href, onClick } = props;
  const [isExporting, setIsExporting] = useState(false);

  const handleClick = async () => {
    if (isExporting) {
      return;
    }

    try {
      setIsExporting(true);
      await Promise.resolve(onClick());
    } finally {
      setIsExporting(false);
    }
  };

  if (onClick) {
    return (
      <button type="button" className="export-btn" onClick={handleClick} disabled={isExporting}>
        {isExporting ? "Exporting..." : "Export Table"}
      </button>
    );
  }

  return (

            <a className="export-btn" href={href} >
        Export Table
        </a>
  )
}




